import React from "react";
import "./hero.css";

function Hero() {
  return (
    <div className="container-hero">
    <div className="logo-div"> </div>
      <div className="title-div">
      
      <div className="stone-background ">
      <h3 class="engraving-text">GRAVSTEN I SVERIGE</h3>

      </div>
      </div>
    </div>
  );
}

export default Hero;
 